import { Component, OnInit } from '@angular/core';
import { Observable } from "rxjs/Observable";
import { AngularFireAuth } from "angularfire2/auth";
import { Shared } from '../shared.service';
import { Router, ActivatedRoute } from '@angular/router';
import * as firebase from 'firebase/app';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {

  password: string;
  email: string;
  user: Observable<firebase.User>;

  constructor(public afAuth: AngularFireAuth, public router: Router, public shared: Shared) {
      afAuth.authState.subscribe(user => {
          if(user){
              shared.current_user = user;
              router.navigate(['/control']);
          }
      })
  }

  ngOnInit() {
  }

  login(){
      this.afAuth.auth.signInWithEmailAndPassword(this.email, this.password);
  }

  enterKey(event){
      if(event.key === "Enter"){
          this.login();
      }
  }
}



// WEBPACK FOOTER //
// ./src/app/login/login.component.ts